import { useEffect } from "react";
import { useOfficeEvents } from "./useOfficeEvents";

/**
 * Reusable hook for components that need Outlook sync
 * Just call this hook to ensure proper synchronization
 */
export const useOfficeSync = () => {
  const { isInitialized, counts, isSyncInProgress } = useOfficeEvents();

  // Auto-trigger sync when component mounts (optional)
  useEffect(() => {
    if (isInitialized) {
      // console.log("🔄 useOfficeSync: Component mounted with Outlook sync");
    }
  }, [isInitialized]);

  return {
    isInitialized,
    counts,
    // Utility methods
    isOutlookSyncReady: isInitialized,
    isSyncInProgress,
  };
};
